import React from "react";
import { Component } from "react";
import WhatsHappeningFilter from "./whats-happening-filter.component";
import WhatsHappeningList from "./whats-happening-list.component";

class WhatsHappening extends Component {
    render(){
        return(
            <div className="whats-happening-wrapper">
                <WhatsHappeningFilter filterData={this.props.filterData} filtersub={this.props.filtersub}/>
                <WhatsHappeningList listData={this.props.listData}/>
            </div>
        )
    }
}

export default WhatsHappening;